module.exports = __webpack_public_path__ + "static/worldsource-logo-89d74f8104af8ea7e582880fb10ac878.jpeg";